//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vComponent from '@/core/vComponent'
import { mapGetters } from 'vuex'
export default {
  name: 'UserInfo',
  extends: vComponent,
  props: {
    useExport: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchObj: {
        sDate: null,
        eDate: null,
        stockNo: '' // 查詢選取的店家
      },
      selectedLabel: '選擇交易門市',
      myLocale: {
        days: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        daysShort: '日_一_二_三_四_五_六'.split('_'),
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        firstDayOfWeek: 1
      }
    }
  },
  computed: {
    ...mapGetters([
      'theme',
      'storeList'
    ]),
    options () {
      const result = [{ label: '全部門市', key: '' }]
      this.storeList.forEach(item => {
        result.push({
          label: item.STORE_NAME,
          key: item.STOCK_NO
        })
      })
      return result
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    onOptionClick (key) {
      this.searchObj.stockNo = key
      let label = null
      this.options.forEach(item => {
        if (key === item.key) label = item.label
      })
      if (label !== null) this.selectedLabel = label
    },
    async doQuery () {
      // 沒有選擇的日期會是null, 選擇店家''代表全部不分店
      console.log(`query from ${this.searchObj.sDate} end ${this.searchObj.eDate} store=${this.searchObj.stockNo}`)
      // if (this.searchObj.sDate === null) this.searchObj.sDate = new Date()
      // if (this.searchObj.eDate === null) this.searchObj.sDate = new Date()
      this.emit('SearchTransactionBar.Search', this.id, {
        STOCK_NO: this.searchObj.stockNo,
        sDate: this.searchObj.sDate,
        eDate: this.searchObj.eDate
      })
    },
    async doExport () {
      // 沒有選擇的日期會是null, 選擇店家''代表全部不分店
      console.log(`query from ${this.searchObj.sDate} end ${this.searchObj.eDate} store=${this.searchObj.stockNo}`)
      // if (this.searchObj.sDate === null) this.searchObj.sDate = new Date()
      // if (this.searchObj.eDate === null) this.searchObj.sDate = new Date()
      this.emit('SearchTransactionBar.Export', this.id, {
        STOCK_NO: this.searchObj.stockNo,
        sDate: this.searchObj.sDate,
        eDate: this.searchObj.eDate
      })
    }
  }
}
